export default __webpack_public_path__ + "shopping-cart.2cda3a4585110ad5.svg";